<button id='ex-buttons-id'
        *ngFor="let exchangeCode of exchangeCodes; let i = index;"
        [class]="'ex-buttons '+(selectedExchangeCode===exchangeCode?'ex-selected':'')"
        (click)="selectExchange(exchangeCode)">
  {{exchangeCode}}
</button>
